/**
 * WordPress dependencies.
 */
import { getElement, store, getContext } from '@wordpress/interactivity';

let debounceTimer = null;

const { state, actions } = store('bv-space', {
	actions: {
		setActiveSearch() {
			const { ref } = getElement();
			const { value } = ref;
			state.searchValue = value;
			actions.updateURL();
		},
		*updateSearch() {
			const { ref } = getElement();
 			const { value } = ref;
			const first_call = new URL(window.location.href).searchParams.get('first_call');
			if (first_call) {
				const url = new URL(window.location.href);
				url.searchParams.delete('first_call');
				window.history.replaceState({}, '', url.toString());
			}
			// Clear existing timer
			if (debounceTimer) {
				clearTimeout(debounceTimer);
			}

			debounceTimer = setTimeout(() => {
				if ( value === state.searchValue ) return;
				state.searchValue = value;
				actions.updateURL();
			}, 200);

			// if ( value === '' ) {
			// 	const { actions } = yield import(
			// 		'@wordpress/interactivity-router'
			// 	);
			// } else {
			// 	yield actions.updateURL();
			// }
		},
	},
} );
